var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRadioUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-21.9%",
    y: "-15.6%",
    width: "143.8%",
    height: "143.8%",
    filterUnits: "objectBoundingBox",
    id: "RadioUnchecked_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "RadioUnchecked_svg__[object_Object]b",
    cx: 8,
    cy: 8,
    r: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#RadioUnchecked_svg__[object_Object]a)",
    xlinkHref: "#RadioUnchecked_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#C0D0DF",
    strokeLinejoin: "square",
    fill: "#FFF",
    cx: 8,
    cy: 8,
    r: 7.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioUnchecked);
export default ForwardRef;